
import get from "lodash/get";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { State } from "../../types/State";
import { checkClanBattles, fetchClanData, getClanBattles, onClickBattle, setSelectedTab, setSelectedTeamNumber } from "../Actions/ActionClanBattles";
import ViewClanBattles from "../Components/ViewClanBattles/ViewClanBattles";
import settings from "../settings";
import { openUrlInExternalBrowser } from "../web2ClientAPI/web2ClientAPI";
import { ClanRec2IsEnabled } from 'helpers/common'
import { isLoggedIn } from "~/utils/auth"

export type ContainerClanBattles_Props = {
  selectedTab: number;
  clanId: number;
  clanBattlesInfoContent: any;
  root: string;
  router: any;
  clanData: any;
  battlesList: any;
  isError: boolean;
  isFetching: boolean;
  selectedBattle: any;
  wowsLadder: any;
  seasonType: string;
  teamNumber: number;
  hasBattles: boolean;

  setSelectedTab: (selectedTab: string) => void;
  getClanBattles: () => void;
  checkClanBattles: () => void;
  fetchClanData: () => void;
  onClickBattle: (battleId: number) => void;
  onBattlePageInfoClick: (url: string) => void;
  setSelectedTeamNumber: (teamNumber: number) => void;
};
export type ContainerClanBattles_State = {};

class ContainerClanBattles extends PureComponent<ContainerClanBattles_Props, ContainerClanBattles_State> {


  componentDidMount() {
    if (isLoggedIn()){
      this.props.checkClanBattles();
    }
  }

  navigateToRecommendations = () => {
    const url = ClanRec2IsEnabled ? 'new-recommendations' : 'recommendations'
    this.props.router.push(this.props.root + url)
  }

  setSelectedTab = (selectedTab: string) => {
    switch (parseInt(selectedTab, 10)) {
      case 0:
        {
          this.props.router.push(`${this.props.root}clan-battles/history`);
          break;
        }
      case 1:
        {
          this.props.router.push(`${this.props.root}clan-battles/rating`);
          break;
        }
      case 2:
        {
          this.props.router.push(`${this.props.root}clan-battles/rules`);
          break;
        }
      default:
        {
          break;
        }

    }
  };

  render() {
    return (
      <ViewClanBattles
        selectedTab={this.props.selectedTab}
        clanId={this.props.clanId}
        clanBattlesInfoContent={this.props.clanBattlesInfoContent}
        clanData={this.props.clanData}
        battlesList={this.props.battlesList}
        isError={this.props.isError}
        isFetching={this.props.isFetching}
        selectedBattle={this.props.selectedBattle}
        wowsLadder={this.props.wowsLadder}
        seasonType={this.props.seasonType}
        teamNumber={this.props.teamNumber}
        hasBattles={this.props.hasBattles}

        setSelectedTab={this.setSelectedTab}
        navigateToRecommendations={this.navigateToRecommendations}
        getClanBattles={this.props.getClanBattles}
        fetchClanData={this.props.fetchClanData}
        onClickBattle={this.props.onClickBattle}
        onBattlePageInfoClick={this.props.onBattlePageInfoClick}
        setSelectedTeamNumber={this.props.setSelectedTeamNumber}
        urlParams={this.props.params}
      />

    )
  }
}

const mapStateToProps = (state: State) => {

  const wowsLadder = state.clans.wowsLadder[state.currentAccount.clanId];
  const lastSeasonId = get(settings, ['ladder', 'lastSeasonId'], null);
  const seasonType = get(settings, ['ladder', 'seasons', lastSeasonId, 'kind'], null);

  const totalBattles = wowsLadder ? wowsLadder.ratings.filter(item => item.season_number === lastSeasonId).map(item => item.battles_count).reduce((a, b) => a + b, 0) : 0;

  return {
    selectedTab: state.ReducerClanBattles.selectedTab,
    clanId: state.currentAccount.clanId,
    clanBattlesInfoContent: state.content.clanBattlesPage,
    root: state.urls.root,

    clanData: state.clans.items[state.currentAccount.clanId],
    battlesList: state.ReducerClanBattles.battlesList,
    isError: state.ReducerClanBattles.isError,
    isFetching: state.ReducerClanBattles.isFetching,
    selectedBattle: state.ReducerClanBattles.selectedBattle,
    wowsLadder: wowsLadder,
    seasonType: seasonType,
    teamNumber: state.ReducerClanBattles.teamNumber,
    hasBattles: totalBattles > 0
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSelectedTab: (selectedTab: number) => {
      dispatch(setSelectedTab(selectedTab));
    },
    getClanBattles: () => {
      dispatch(getClanBattles());
    },
    fetchClanData: () => {
      dispatch(fetchClanData());
    },
    onClickBattle: battleId => {
      dispatch(onClickBattle(battleId));
    },
    onBattlePageInfoClick: url => {
      openUrlInExternalBrowser(url);
    },
    setSelectedTeamNumber: (teamNumber: number) => {
      dispatch(setSelectedTeamNumber(teamNumber));
    },
    checkClanBattles: () => {
      dispatch(checkClanBattles());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerClanBattles);